import { render, staticRenderFns } from "./SecurityLogsViewer.vue?vue&type=template&id=54b44d7f&scoped=true&"
import script from "./SecurityLogsViewer.vue?vue&type=script&lang=js&"
export * from "./SecurityLogsViewer.vue?vue&type=script&lang=js&"
import style0 from "./SecurityLogsViewer.vue?vue&type=style&index=0&id=54b44d7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b44d7f",
  null
  
)

export default component.exports